
export {} from '@clayui/progress-bar';
import __x__ from '@clayui/progress-bar';export default __x__;